"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryItemEdit = HistoryItemEdit;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
const ApplicationDetailModal_style_1 = require("./HiringProcessColumns/ApplicationDetailModal/ApplicationDetailModal.style");
function HistoryItemEdit({ historyItem, onEdit, editHistoryItemText, setEditHistoryItemText, setEditingHistoryItem, }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ApplicationDetailModal_style_1.InputTextArea, { autoSize: true, value: editHistoryItemText, onChange: e => {
                    setEditHistoryItemText(e.target.value);
                } }), (0, jsx_runtime_1.jsx)(elements_1.Button, { className: "m-t-s m-b-s", type: "default", size: "small", onClick: () => {
                    setEditHistoryItemText('');
                    setEditingHistoryItem(false);
                }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.hiring_process.detail_modal.cancel" }) }), (0, jsx_runtime_1.jsx)(elements_1.Button, { className: "m-t-s m-b-s m-l-s", type: "primary", size: "small", disabled: Boolean(!editHistoryItemText) || editHistoryItemText === historyItem.message, onClick: () => onEdit(historyItem.id, editHistoryItemText), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.hiring_process.detail_modal.save_changes" }) })] }));
}
